import gCard from "@/components/g-card/g-card.vue"
import gButton from "@/components/g-button/g-button.vue"
import gForm from "@/components/g-form/g-form.vue";
import axios from 'axios';
import gPdf from "@/components/g-pdf/g-pdf.vue";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import OrcamentoSequenciaController from "@/shared/controllers/orcamentoSequencia/orcamentoSequenciaController";
import ConsultarOrcamentoPDF from '../../../ConsultarOrcamento/PDF/ConsultarOrcamentoPDF';

const name = 'OrcamentoFinalRA'

export class PhotoService {
  async getImage(OrcamentoSelecionado, images) {
    await axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Produto/GetImagesByOrcamentoId/${OrcamentoSelecionado}`,
    }) .then((response) => {
      images = response.data.data
    })
    .catch(() => {
    });

    return images
  }
}

export default {
  name,

  components: {
    'g-card':gCard,
    'g-button': gButton,
    'g-form': gForm,
    'g-pdf': gPdf,
    'ConsultarOrcamentoPDF' : ConsultarOrcamentoPDF
   },

  props: { },

  mounted () {
    var OrcamentoId = this.$route.params.id
    this.OrcamentoSelecionado = OrcamentoId
    this.InformacoesCaracteristicas()
    this.InformacoesClienteByOrcamentoId()
    this.InformacoesLoteFreteByOrcamentoId()
    this.InformacoesOrcamentoComponenteByOrcamentoId()
    this.InformacoesOrcamentoProdutoByOrcamentoId()
    this.InformacoesOrcamentoQuantidadeByOrcamentoId()
    this.InformacoesByOrcamentoId()
    this.Observacao()
    this.getOrcamentoSequencia()

    this.options.push("0")
    this.options.push("1")

    this.RotaImagem()

    this.chamarImagem()
  },

  galleriaService: null,
  created (){
    this.galleriaService = new PhotoService();
  },

  updated () { },

  data () {
    return {
      caminhoImagem: null,
      MelhorAproveitamento: '',
      LarguraPalete: '',
      AlturaPalete: '',
      ComprimentoPalete: '',
      ObservacaoPalete: '',
      DesabilitaCheckBox: false,
      DescricaoLote: [],
      InformacaoClienteArray:[],
      InformacaoLoteFreteArray:[],
      InformacaoObservacao: [],
      InformacaoObservacoesGerais: [],
      InformacaoOrcamentoComponenteArray:[],
      InformacaoOrcamentoProdutoArray:[],
      InformacaoOrcamentoQuantidadeArray: [],
      options: [],
      orcamento:'',
      OrcamentoCritica: [],
      OrcamentoCritica1: [],
      OrcamentoCritica2: [],
      OrcamentoCritica3: [],
      OrcamentoCritica4: [],
      OrcamentoCritica5: [],
      OrcamentoEmbalagem: [],
      OrcamentoEmbalagemCaixaColetiva: [],
      OrcamentoEmbalagemDescOutros: [],
      OrcamentoEmbalagemFilme: [],
      OrcamentoEmbalagemOutros: [],
      OrcamentoEmbalagemPalete: [],
      OrcamentoGerais: [],
      OrcamentoGeraisFsc: [],
      OrcamentoGeraisLegislacao: [],
      OrcamentoSelecionado: null,
      OrcaQuantidade: [],
      OrcaQuantidadeDiaCarregamento: [],
      RazaoSocialText:null,
      riscoFacaProt: [],
      images:{
        arquivo:'',
        arquivobase64: '',
        files: '',
        id: '',
        produto:'',
        },
        executarvisualizacao: 0,
        renderiza: false,
        InformacaoProdutosSequencia: [],
        ICMS: null,
        IPI: null,
        PisCofins: null,
        temLote: false,
        temSequencia: false,
        papelSeda: false,
        medidaPapelSeda: '',
        medidaPapelSeda2: '',
        styleImg: ''
     }
      //orcamentoId: this.$route.params.id

  },

  methods: {
    getOrcamentoSequencia(){
      OrcamentoSequenciaController.GetOrcamentoSequenciaByOrcamentoId(this.$route.params.id).requisicao
      .then(res => {
        this.InformacaoProdutosSequencia = res.data.data.informacaoProdutosSequencia
      });
    },
    RetornaQtdLinha1() {
      return !this.temLote ? "3" : "2"
    },
    RetornaQtdLinha2() {
      return !this.temSequencia ? "3" : "2"
    },



    GridSequencia1(){
      return !this.temLote ? "3 / 1 / 4 / 2" : "2 / 2 / 3 / 3"
    },
    GridSequencia2(){
      return !this.temLote ? "2 / 2 / 3 / 3" : "2 / 1 / 3 / 2"
    },
    GridSequencia3(){
      return !this.temLote ? "2 / 1 / 3 / 2" : "1 / 4 / 2 / 5"
    },
    GridSequencia4(){
      return !this.temLote ? "1 / 5 / 2 / 6" : "1 / 4 / 2 / 5"
    },
    GridDescricaoSequencia1(){
      return !this.temLote ? "3 / 2 / 4 / 3" : "3 / 1 / 4 / 2"
    },
    GridDescricaoSequencia2(){
      return !this.temLote ? "2 / 3 / 3 / 4" : "2 / 2 / 3 / 3"
    },
    GridDescricaoSequencia3(){
      return !this.temLote ? "2 / 2 / 3 / 3" : "2 / 1 / 3 / 2"
    },
    GridDescricaoSequencia4(){
      return !this.temLote ? "1 / 6 / 2 / 7" : "1 / 5 / 2 / 6"
    },


    novo_orcamento(){
      this.$router.push('/produto-repeticao-alteracao-inicio')
    },
    consultarorcamento(){
      this.$router.push('/consultar-orcamento')
    },


  computed: { },

    NumeroRamalExibicao(){
      let valoresInvalidos = [undefined, null, 0, '', '0'];
      if(valoresInvalidos.includes(this.InformacaoClienteArray.numeroRamal)) return '--';
      return this.InformacaoClienteArray.numeroRamal;
    },

    InformacoesClienteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Cliente/GetClienteByOrcamento/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoClienteArray = response.data.data
        this.ICMS = this.InformacaoClienteArray.icms
        this.IPI = this.InformacaoClienteArray.ipi
        this.PisCofins = this.InformacaoClienteArray.pisCofins
        this.incentivos()
      })
      .catch(() => {
      });
    },

    erro(e){
      if(e == undefined){
        this.caminhoImagem = 'http://' + window.location.host + '/repositorio/Ilustracao_Nenhuma_Img.svg'
        this.styleImg = 'width: 100px'
      }
    },

    incentivos(){
      this.incentivos
      if (this.ICMS === true){
      this.ICMS = ("ICMS   ")
      } else{
      this.ICMS = ("")
      }

      if (this.IPI === true){
      this.IPI = ("IPI   ")
      } else{
      this.IPI = ("")
      }

      if (this.PisCofins === true){
      this.PisCofins = ("PisCofins")
      } else{
        this.PisCofins = ("")
      }
    },

    InformacoesLoteFreteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `LoteFrete/GetLoteFreteFinalByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoLoteFreteArray = response.data.data
        this.riscoFacaProt = response.data.data.RiscoFacaPrototipo;
        if (this.InformacaoLoteFreteArray.informacaoLoteText !== 'Não'){
          this.temLote = false
        }else{
          this.temLote = true
        }
        if(this.InformacaoLoteFreteArray.sequencia != false){
          this.temSequencia = false
        }else{
          this.temSequencia = true
        }
      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoComponenteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoComponente/GetOrcamentoComponenteProdutoNovoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoOrcamentoComponenteArray = response.data.data
        this.DesabilitaCheckBox = true;
                this.InformacaoOrcamentoComponenteArray.forEach((r)=>{
          r.embalagens = []
          r.embalagemEspecificaFilmeEncolhivel == true ? r.embalagens.push('Filme encolhível - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
          r.embalagemEspecificaCaixaColetiva == true  ? r.embalagens.push('Caixa Coletiva - ' + `${r.quantidadeCaixaColetiva}`) : ''
          r.embalagemEspecificaPalete == true  ? r.embalagens.push('Palete - ' + `${r.quantidadePalete}`) : ''
          r.embalagemEspecificaPapelEmbrulho == true  ? r.embalagens.push('Papel Embrulho - ' + `${r.quantidadePapelEmbrulho}`) : ''
          r.quantidadeOutros == null || 0  ? '' : r.embalagens.push(r.descricaoEmbalagemOutros == null || '' ? 'Outros -' : r.descricaoEmbalagemOutros + `${r.quantidadeOutros}`) 

        })
      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoProdutoByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoProduto/GetOrcamentoProdutoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoOrcamentoProdutoArray = response.data.data
      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoQuantidadeByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoQuantidade/GetOrcamentoQuantidadeByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoOrcamentoQuantidadeArray = response.data.data
        this.OrcaQuantidade = response.data.data
        this.OrcaQuantidadeDiaCarregamento = response.data.data
        this.OrcaQuantidadeDiaCarregamento  = this.dataCarregamento(this.OrcaQuantidadeDiaCarregamento)
      })
     .catch(() => {
      });
    },

    InformacoesByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetOrcamentoById/Get/${this.OrcamentoSelecionado}`,
     })
     .then((response) => {
        onchange
        this.InformacaoOrcamentoArray = response.data.data
        this.nomeRepre = response.data.data.nomeRepresentante
        this.Empresa = response.data.data.nome
        this.InformacaoObservacoesGerais = response.data.data.observacoesGerais
        this.orcamento = response.data.data.codigoExterno
      })
     .catch(() => {
      });
    },

    InformacoesCaracteristicas(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetCaracteristicasProdutoFinalByOrcamentoId/Get/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.OrcamentoGeraisFsc = response.data.data.fsc
        this.OrcamentoGeraisLegislacao = response.data.data.legislacao
        this.OrcamentoDescricaoSequencia = response.data.data.descricaoSequencia

        this.OrcamentoEmbalagemFilme = response.data.data.embalagemEspecificaFilmeEncolhivel
        this.OrcamentoEmbalagemCaixaColetiva = response.data.data.embalagemEspecificaCaixaColetiva
        this.OrcamentoEmbalagemPalete = response.data.data.embalagemEspecificaPalete
        this.OrcamentoEmbalagemOutros = response.data.data.embalagemOutros
        this.OrcamentoEmbalagemDescOutros = response.data.data.descricaoOutrasEmbalagens

        this.OrcamentoCritica1 = response.data.data.critica1
        this.OrcamentoCritica2 = response.data.data.critica2
        this.OrcamentoCritica3 = response.data.data.critica3
        this.OrcamentoCritica4 = response.data.data.critica4
        this.OrcamentoCritica5 = response.data.data.critica5

        this.papelSeda = response.data.data.papelSeda
        this.medidaPapelSeda = response.data.data.medidaPapelSeda 
        this.medidaPapelSeda2 = response.data.data.medidaPapelSeda2

        let alturaPalete = response.data.data.alturaPalete;
        let larguraPalete = response.data.data.larguraPalete;
        let comprimentoPalte = response.data.data.comprimentoPalete;

        this.DescricaoLote = response.data.data.lote
        this.MelhorAproveitamento = response.data.data.melhorAproveitamento
        this.AlturaPalete =  alturaPalete ? alturaPalete + ' cm' : '--',
        this.LarguraPalete = larguraPalete ? larguraPalete + ' cm' : '--'
        this.ComprimentoPalete = comprimentoPalte ? comprimentoPalte + ' cm' : '--'
        this.ObservacaoPalete = response.data.data.observacaoPalete
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    Observacao(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoQuantidade/GetObservacaoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoObservacao = response.data.data.observacao
      })
      .catch(() => {
      });
    },

    RotaImagem(){
      OrcamentoController.GetRotaImagemProduto(this.$route.params.id).requisicao
      .then(res => {
        const urlBase = window.location.host
        if(res.data.data === 'erro'){
          this.erro(undefined)
          return
        }
        this.caminhoImagem = `http://${urlBase}/${res.data.data}`;
        this.styleImg = 'width: 400px'

      })
    },

    async chamarImagem(){
      this.images = await this.galleriaService.getImage(this.OrcamentoSelecionado, this.images)
    },

    gerarPdf(){
      this.generatePdf()
    },

    generatePdf() {
      this.executarvisualizacao++
    },

    pdfFinal(){
        this.renderiza = true
        this.executarvisualizacao++
        this.OrcamentoSelecionado = this.$route.params.id
    },

    dataCarregamento(diasCarregamento){
      diasCarregamento = diasCarregamento.map(obj=>{
        if(!obj.dataCarregamentoFormato){
          obj.dataCarregamentoFormato = ("N/A")
        }
        return diasCarregamento
      })
      return diasCarregamento
    }
  },

  computed: { },
};